export default __webpack_public_path__ + "static/media/Snd_TryO.0f18af74.mp3";